import React from 'react';
import SEOHead from '../components/SEOHead';
import Navbar from '../components/Navbar';
import HeroSlider from '../components/HeroSlider';
import Services from '../components/Services';
import About from '../components/About';
import VideoSection from '../components/VideoSection';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <SEOHead />
      <Navbar />
      <main id="main-content">
        <HeroSlider />
        <Services />
        <About />
        <VideoSection />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default Home;
